import { render } from "./BulkDatabaseElementTable.vue?vue&type=template&id=545c6a10&scoped=true&ts=true"
import script from "./BulkDatabaseElementTable.vue?vue&type=script&lang=ts"
export * from "./BulkDatabaseElementTable.vue?vue&type=script&lang=ts"

import "./BulkDatabaseElementTable.vue?vue&type=style&index=0&id=545c6a10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545c6a10"]])

export default __exports__